import React from 'react';
import { MoreVert } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { Checkbox } from '@mui/material';

import { useBuilderStore } from './store';
import Menu from 'components/Menu';

const useStyles = makeStyles({
  '@global': {
    '.vert-menu': {
      border: '1px solid #000',
      backgroundColor: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 36,
      height: 'auto',
      cursor: 'pointer',
      transform: 'scale(0.5)',
    },
    '.vert-menu-menu-overrides': {
      border: 'none',
      color: '#000',
    },
    '.menu': {
      padding: 10,
      transform: 'translateY(-1.5px)',
    },
  },
});

const VertMenu = () => {
  useStyles();
  const honeymoon = useBuilderStore(state => state.data.honeymoon);
  const setHoneymoon = useBuilderStore(state => state.actions.accommodations.setHoneymoon);

  return (
    <div className="vert-menu">
      <Menu
        name="more options"
        icon={<MoreVert />}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        items={[
          {
            label: (
              <>
                Honeymoon Trip <Checkbox color="secondary" checked={honeymoon} />
              </>
            ),
            onClick: () => setHoneymoon(!honeymoon),
          },
        ]}
        classes={{ menu: 'vert-menu-menu-overrides' }}
      />
    </div>
  );
};

export default VertMenu;
